import * as React from 'react'
import { Modal, Form, Button } from 'antd'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { closeEditAction } from './types'
import BillForm from './BillForm'
import { option } from 'fp-ts'
import moment from 'moment'
import { useUpdateBill } from './queries'
import { NewOrganizationInvoice, NewSupplierInvoice } from '../../types'

const datesToMoments = ({
  createdAt,
  dueAt,
  ...b
}: NewSupplierInvoice | NewOrganizationInvoice) => ({
  ...b,
  createdAt: moment(createdAt),
  dueAt: moment(dueAt),
})

type BillWithMoments = ReturnType<typeof datesToMoments>

const EditBillModal = () => {
  const visible = useSelector(s => option.isSome(s.bills.editBill))
  const bill = useSelector(s => option.toUndefined(s.bills.editBill))
  const updateBill = useUpdateBill(bill?.id)
  const dispatch = useDispatch()

  const [form] = Form.useForm<BillWithMoments>()

  React.useEffect(() => {
    form.resetFields()
  }, [visible, bill?.id])

  return (
    <Modal
      zIndex={1}
      visible={visible}
      cancelText={<FormattedMessage id="cancel" />}
      okText={<FormattedMessage id="confirm" />}
      onCancel={() => dispatch(closeEditAction())}
      onOk={form.submit}
      okButtonProps={{ loading: updateBill.isLoading }}
      destroyOnClose={true}
      width="100%"
      style={{ maxWidth: '800px' }}
    >
      <Button onClick={() => form.resetFields()}>Reset</Button>
      {!!bill && (
        <BillForm
          title={<FormattedMessage id="editInvoice" />}
          form={form}
          onFinish={b => {
            if (!b.payer) {
              console.error('update bill has no payer', b)
              return
            }

            updateBill.mutate(
              {
                reference: b.reference,
                unitID: b.unitID,
                amount: b.amount,
                createdAt: b.createdAt.toDate(),
                dueAt: b.dueAt.toDate(),
                customer: b.payer,
                items: b.items,
                discount: b.discount,
                tax: b.tax,
                notifyPhonenumber: undefined,
                urlOk: undefined,
                urlFailed: undefined,
              },
              {
                onSuccess: () => {
                  dispatch(closeEditAction())
                },
              }
            )
          }}
          initialValue={bill}
        />
      )}
    </Modal>
  )
}

export default EditBillModal
